import { createFileRoute } from '@tanstack/react-router';
import { AccessRequestsPage } from '@/features/preparer/access-requests/AccessRequestsPage';
import { z } from 'zod';
import { userSettingQueryOptions } from '@/lib/query/options';

// Define search params schema for sticky filtering/pagination
const accessRequestsSearchSchema = z.object({
  page: z.number().int().positive().optional().catch(undefined),
  pageSize: z.number().int().positive().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  officeId: z.string().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  sortBy: z.string().optional().catch(undefined),
  sortOrder: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/preparer/access-requests/')({
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | { token?: string; isAuthenticated?: boolean }
      | undefined;

    if (authState?.token) {
      queryClient.prefetchQuery(userSettingQueryOptions.current(authState.token)).catch(() => {});
    }
  },
  component: AccessRequestsPage,
  validateSearch: accessRequestsSearchSchema,
});
